import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  BoletosClienteResponse,
  BoletosUnificadosResponse,
  ConsultaBoletoPdfRequest,
  SepararBoletosUnificadosRequest
} from 'src/models/interfaces/boleto/boleto-interface';
import { HeadersService } from '../header.service';
@Injectable({
  providedIn: 'root'
})
export class BoletoService {
  private readonly url = `${environment.apiUrl}/api/v1/boletos`;

  constructor(private readonly http: HttpClient, private headersService: HeadersService) {
    this.headersService.includeObject({ fileName: 'boleto.service.ts', url: this.url });
  }

  gerarBoleto(id: number, sistemaRequisicao: string, tipoBoleto: number): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: '*/*' });

    return this.http
      .get<any>(`${this.url}?id=${id}&sistemaRequisicao=${sistemaRequisicao}&tipoBoleto=${tipoBoleto}`, {
        headers: headers,
        responseType: 'blob' as 'json',
        observe: 'response'
      })
      .pipe(
        map((pdf: HttpResponse<Blob>) => {
          const pdfBlob: Blob = pdf.body!;
          return pdfBlob;
        })
      );
  }

  listarDadosBasicoAntecipados(): Observable<Array<BoletosClienteResponse>> {
    return this.http
      .get<{ boletos?: BoletosClienteResponse[] }>(`${this.url}/antecipados/pre-pagos`)
      .pipe(map((response) => response.boletos || []));
  }

  consultarPdfBoletos(request: ConsultaBoletoPdfRequest): Observable<any> {
    const idParceria = localStorage.getItem('idParceria');
    if (idParceria == '2') {
      request.pedidos.forEach((pedido) => {
        pedido.idParceria = 2;
      });
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', Accept: '*/*' });
    return this.http
      .post<any>(`${this.url}/pdfs`, request, {
        headers: headers,
        responseType: 'blob' as 'json',
        observe: 'response'
      })
      .pipe(
        map((pdf: HttpResponse<Blob>) => {
          const pdfBlob: Blob = pdf.body!;
          const fileURL = URL.createObjectURL(pdfBlob);
          const baseUrl = window.location.origin;
          let title = '';
          if (request.pedidos.length > 1) {
            title = 'boletos.pdf';
          } else {
            title = `boleto_${request.pedidos[0].id}`;
          }
          const pdfViewerUrlWithParam = `${baseUrl}/pdf-viewer?pdf=${encodeURIComponent(fileURL)}&title=${title}`;
          window.open(pdfViewerUrlWithParam);
        })
      );
  }

  listarDadosBoletosPosPagos(): Observable<Array<BoletosClienteResponse>> {
    let url = `${this.url}/pos-pagos`;
    return this.http.get<{ boletos: BoletosClienteResponse[] }>(url).pipe(map((response) => response.boletos));
  }

  listarDadosBoletosPrePagos(
    
    idSessao?: string,
    idParceria?: string,
    possuiPedidoGerado?: boolean
  ): Observable<Array<BoletosClienteResponse>> {
    let url = `${this.url}/pre-pagos`;
    
    if (idParceria == '2') {
      url += '?pedidoGerado=&idParceria=2&idSessao=0';
    }
    return this.http.get<{ boletos: BoletosClienteResponse[] }>(url).pipe(map((response) => response.boletos));
  }

  separarBoletosUnificados(boletos: SepararBoletosUnificadosRequest[]): Observable<any> {
    return this.http.post<any>(`${this.url}/separar-unificados`, boletos);
  }

  listarDadosBoletosUnificadosPrePagos(): Observable<Array<BoletosUnificadosResponse>> {
    return this.http
      .get<{ boletos: BoletosUnificadosResponse[] }>(`${this.url}/unificados/pre-pagos`)
      .pipe(map((response) => response.boletos));
  }

  unificar(idsPedidos: Array<number>): Observable<any> {
    return this.http.post<any>(`${this.url}/unificar`, { idsPedidos: idsPedidos });
  }
}
